export enum ScreenSize {
    SCREEN_SM_MAX = 767
}
